"use strict";
window._theme = window._theme || {};
$(document).ready(function(){

    $('.top-seller-products .shop_now_below').on('click', function() {
        $('body').addClass('popup-active');
        $('.popup-main-gia-lucca').addClass('hide');
        $(this).next('.popup-main-gia-lucca').removeClass('hide');
    });
    $('.close_popup_main').on('click', function() {
      $('body').removeClass('popup-active');
      $('.popup-main-gia-lucca').addClass('hide');
    });
  

  
   
      
        
        $(".inner_popup_content .add_to_cart.checkout_main").on("click", function(){
          var variant_id = $(this).attr('data-pro-id');
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: variant_id
            },
            dataType: 'json',
            success: function(data) {
             window.location.href = '/checkout'
            }
          });
        }); 
      $(".inner_popup_content .add_to_cart.Atc_main").on("click", function(){
        $('body').removeClass('popup-active');
        $('.popup-main-gia-lucca').addClass('hide');
        var variant_id = $(this).attr('data-pro-id')
        var var_num_id = parseInt(variant_id)
        
        _theme.Helpers.addProductToCart(var_num_id, 1, null, function(resp) {
          _theme.MiniCart.lineItemChangeCallBack(resp, function() {
              _theme.toggleLoading();
              _theme.toggleSideCart(1, $(this), true);
          });
      });
      })
})